<template>
	<div :class="{'root': true, sideMenu}">
		<Sidebar />

		<div class="wrap">
			<div class="content">
				<transition name="router-animation">
					<router-view />
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
import Sidebar from '../SideBar/SideBarItem.vue';
import { mapState } from 'vuex'

export default {
	name: 'LayoutItem',
	components: { Sidebar },
    computed: {
        ...mapState(['sideMenu'])
    }
};
</script>

<style src="./index.scss" lang="scss" />